import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reset-transaction-password-popup" }
const _hoisted_2 = { class: "type-wrap flex" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "input-form horizontal"
}
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "input-label" }
const _hoisted_7 = { class: "input-box" }
const _hoisted_8 = { class: "suffix-wrap" }
const _hoisted_9 = { class: "input-row" }
const _hoisted_10 = { class: "input-label" }
const _hoisted_11 = { class: "input-box" }
const _hoisted_12 = { class: "suffix-wrap" }
const _hoisted_13 = { class: "input-row" }
const _hoisted_14 = { class: "input-label" }
const _hoisted_15 = { class: "input-box" }
const _hoisted_16 = { class: "suffix-wrap" }
const _hoisted_17 = {
  key: 1,
  class: "input-form"
}
const _hoisted_18 = { class: "input-row" }
const _hoisted_19 = { class: "input-box" }
const _hoisted_20 = { class: "input-row" }
const _hoisted_21 = { class: "input-box" }
const _hoisted_22 = {
  key: 1,
  class: "sms-btn disabled"
}
const _hoisted_23 = { class: "input-row" }
const _hoisted_24 = { class: "input-box" }
const _hoisted_25 = { class: "suffix-wrap" }

import { ref, reactive, computed, inject, onUnmounted, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'
import md5 from 'js-md5';
import PopupForm from '@/components/PopupForm.vue';
import { useUserStore } from '@/store';
import { resetTradePwd, resetTradePwdOTP } from "@/api"; 


export default {
  __name: 'ResetPassword',
  props: ['phone'],
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const MyToast = inject('myToast')

const { t } = useI18n()

const userStore = useUserStore()

const typeList = ref([]);
const activeType = ref(null);
const showPassword = ref(false)
const coldDownTime = ref(0);
const coldDownInterval = ref(null);
const form = reactive({
  password: '',
  confirmPwd: '',
  oldPassword: '',
  verifyCode: '',
})

const smsDisabled = computed(() => {
  return false;
})

const submitDisabled = computed(() => {
  if (activeType.value.code === 1) {
    return form.password === '' || form.confirmPwd === '' || form.password !== form.confirmPwd || !/^[A-Za-z0-9]{6,12}$/.test(form.password);
  } else {
    return form.password.length < 6 || form.verifyCode.length < 6 || !/^[A-Za-z0-9]{6,12}$/.test(form.password);
  }
  
})

onMounted(() => {
  typeList.value = [{ code: 1, title: t('common.modify') }, { code: 2, title: t('common.reset') }]
  activeType.value = typeList.value[0];
})

onUnmounted(() => {
  if(coldDownInterval.value) {
    clearInterval(coldDownInterval.value);
  }
})

const coldDown = () => {
  if (coldDownInterval.value) {
    clearInterval(coldDownInterval.value);
  }
  coldDownInterval.value = setInterval(() => {
    coldDownTime.value = coldDownTime.value - 1;
    if (coldDownTime.value === 0) {
      clearInterval(coldDownInterval.value);
    }
  }, 1000)
}

const sendVerifyCode = () => {
  if (smsDisabled.value) {
    return false;
  }
  resetTradePwdOTP().then(res => {
    coldDownTime.value = 60;
    coldDown();
  });
}

const doReset = () => {
  resetTradePwd({
    password: md5(form.password),
    verifyCode: form.verifyCode,
  }).then(res => {
    MyToast({ type: 'success', message: t('notify.operateSuccess') });
    emit('onClose');
  });
}

const doModify = () => {
  userStore.updateTransactionPwd({ 
    password: md5(form.password),
    oldPassword: md5(form.oldPassword),
  }, () => {
    MyToast({ type: 'success', message: t('notify.operateSuccess') });
    emit('onClose');
  })
}

const inputBlur = (e) => {
  let field = e.target.name
  if (field) {
    form[field] = form[field].replace(/ +/g, '');
  }
}

return (_ctx, _cache) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PopupForm, {
      title: _ctx.$t('user.securityCenter.transactionPwd.title'),
      onOnClose: _cache[9] || (_cache[9] = $event => (emit('onClose')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`type-item ${activeType.value === item ? 'active' : ''}`),
              key: item.code,
              onClick: $event => (activeType.value = item)
            }, [
              _createTextVNode(_toDisplayString(item.title), 1)
            ], 10, _hoisted_3)), [
              [_directive_audio]
            ])
          }), 128))
        ]),
        (activeType.value && activeType.value.code === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('label.oldPwd')) + ":", 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_van_field, {
                    modelValue: form.oldPassword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.oldPassword) = $event)),
                    name: "oldPassword",
                    class: "input-field",
                    type: !showPassword.value ? 'password' : 'text',
                    clearable: ""
                  }, null, 8, ["modelValue", "type"]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createVNode(_component_van_icon, {
                      class: "eye-icon",
                      name: !showPassword.value ? 'eye-o' : 'closed-eye',
                      onClick: _cache[1] || (_cache[1] = $event => (showPassword.value=!showPassword.value))
                    }, null, 8, ["name"]), [
                      [_directive_audio]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('label.newPwd')) + ":", 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_van_field, {
                    modelValue: form.password,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((form.password) = $event)),
                    name: "password",
                    class: "input-field",
                    type: !showPassword.value ? 'password' : 'text',
                    onBlur: inputBlur,
                    clearable: ""
                  }, null, 8, ["modelValue", "type"]),
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createVNode(_component_van_icon, {
                      class: "eye-icon",
                      name: !showPassword.value ? 'eye-o' : 'closed-eye',
                      onClick: _cache[3] || (_cache[3] = $event => (showPassword.value=!showPassword.value))
                    }, null, 8, ["name"]), [
                      [_directive_audio]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('label.confirmPwd')) + ":", 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_van_field, {
                    modelValue: form.confirmPwd,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((form.confirmPwd) = $event)),
                    name: "confirmPwd",
                    class: "input-field",
                    type: !showPassword.value ? 'password' : 'text',
                    onBlur: inputBlur,
                    clearable: ""
                  }, null, 8, ["modelValue", "type"]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createVNode(_component_van_icon, {
                      class: "eye-icon",
                      name: !showPassword.value ? 'eye-o' : 'closed-eye',
                      onClick: _cache[5] || (_cache[5] = $event => (showPassword.value=!showPassword.value))
                    }, null, 8, ["name"]), [
                      [_directive_audio]
                    ])
                  ])
                ])
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                class: "submit-btn",
                disabled: submitDisabled.value,
                onClick: doModify
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])), [
                [_directive_audio]
              ])
            ]))
          : (activeType.value && activeType.value.code === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "input-box width-auto" }, [
                    _createElementVNode("div", { class: "input-text" }, "+63")
                  ], -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_van_field, {
                      "model-value": __props.phone,
                      name: "phone",
                      class: "input-field",
                      readonly: ""
                    }, null, 8, ["model-value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_van_field, {
                      modelValue: form.verifyCode,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((form.verifyCode) = $event)),
                      name: "verifyCode",
                      class: "input-field",
                      placeholder: _ctx.$t('placeholder.otp'),
                      type: "digit",
                      maxlength: "6",
                      onBlur: inputBlur,
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  (coldDownTime.value === 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(`sms-btn ${smsDisabled.value ? 'disabled' : ''}`),
                        onClick: sendVerifyCode
                      }, _toDisplayString(_ctx.$t('common.send')), 3))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(coldDownTime.value) + _toDisplayString(_ctx.$t('common.second')), 1))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_van_field, {
                      modelValue: form.password,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((form.password) = $event)),
                      name: "password",
                      class: "input-field",
                      placeholder: _ctx.$t('placeholder.password'),
                      type: !showPassword.value ? 'password' : 'text',
                      onBlur: inputBlur,
                      maxlength: "12",
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder", "type"]),
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createVNode(_component_van_icon, {
                        class: "eye-icon",
                        name: !showPassword.value ? 'eye-o' : 'closed-eye',
                        onClick: _cache[8] || (_cache[8] = $event => (showPassword.value=!showPassword.value))
                      }, null, 8, ["name"]), [
                        [_directive_audio]
                      ])
                    ])
                  ])
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                  class: "submit-btn",
                  block: "",
                  disabled: submitDisabled.value,
                  onClick: doReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])), [
                  [_directive_audio]
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

}